import { Center, NavLink, Stack, Text } from "@mantine/core";
import "./Side.css";
import SideItem from "./SideItem";
import { useDispatch, useSelector } from "react-redux";
import { setItemSelected } from "../../../store/features/sidebarSlice";
import { RootState } from "../../../store/store";
import UserAvatar from "./UserAvatar";
import { logout } from "../../../store/features/authSlice";
import { useNavigate } from "react-router";
import { IconLogout } from "@tabler/icons-react";
import packageJson from '../../../../package.json';
import { PaymentInformation } from "common";

const Side = (props: { onItemPressed: () => void }) => {
    const dispatch = useDispatch();
    const itemSelected = useSelector((state: RootState) => state.sidebar.itemSelected);
    const user = useSelector((state: RootState) => state.auth);

    const navigate = useNavigate();

    const hasSelfCheckin = user.attrs.payment && 
        (user.attrs.payment as PaymentInformation).subscriptionHistory
            .some((p) => p.type === "ltd_selfcheckin");

    const onPressHandler = (itemName: string) => {
        dispatch(setItemSelected(itemName));
        
        props.onItemPressed();
    };

    const logoutHandler = () => {
        dispatch(logout());

        localStorage.removeItem("token");

        navigate("/login");
    };

    return(
        <div className="side">
            <Stack>
                <SideItem 
                    label={`Abbonamento`}
                    icon="credit_card"
                    isSelected={ itemSelected === 'subscriptions' }
                    onPress={ () => onPressHandler('subscriptions') } 
                />
                <SideItem 
                    label={`Il tuo profilo`}
                    icon="person"
                    isSelected={ itemSelected === 'profile' }
                    onPress={ () => onPressHandler('profile') } 
                />

                {hasSelfCheckin && (
                    <SideItem 
                        label="Configura Informativa Privacy"
                        icon="file_description"
                        isSelected={itemSelected === 'privacy-config'}
                        onPress={() => onPressHandler('privacy-config')} 
                    />
                )}

                {/* Add next here... */}
            </Stack>
            
            <div style={{ height: '60%' }}></div>
            
            <Stack justify="flex-end">
                <UserAvatar user={ user } />
                
                <Center>
                    <NavLink rightSection={ <IconLogout /> } label="Logout" active onClick={ logoutHandler } />
                </Center>

                <Center>
                    <Text fz="sm" lh="md" c="dimmed" fs="italic">
                        v{ packageJson.version }
                    </Text>
                </Center>
            </Stack>
        </div>
    );
};

export default Side;